import { Component } from '@angular/core';

@Component({
  selector: 'lomas-not-found-page',
  templateUrl: './notfound-page.component.html'
})
export class NotFoundComponent {

}
